/* eslint-disable no-unused-vars */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useQuery } from "@redux-requests/react";
import { Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { Loader } from "../../components";
import { SubmitButton, TextField } from "../../components/formik";
import { types } from "../../ducks";
import { createForumTopic, getForumTopic, updateForumTopic } from "../../ducks/actions";
import { useActionRequest } from "../../hooks";

const EditForumTopicDialog = ({ id, onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) dispatch(getForumTopic({ id }));
  }, [dispatch, id]);

  const {
    data: { data: forumTopic },
    loading: forumTopicLoading
  } = useQuery({ type: types.GET_FORUM_TOPIC, defaultData: { data: {} } });

  const createForumTopicRequest = useActionRequest({
    action: createForumTopic
  });
  const updateForumTopicRequest = useActionRequest({
    action: updateForumTopic
  });

  const initialValues = id
    ? {
        title: "",
        body: "",
        ...forumTopic
      }
    : { title: "", body: "" };
  const validationSchema = yup.object().shape({
    title: yup.string().required(),
    body: yup.string().required()
  });
  const onSaveForumTopic = forumTopic => {
    if (forumTopic.id) updateForumTopicRequest(forumTopic);
    else createForumTopicRequest(forumTopic);
    onClose();
  };

  return (
    <Formik
      validationSchema={validationSchema}
      onSubmit={onSaveForumTopic}
      initialValues={initialValues}
    >
      <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
        <DialogContent>
          <Loader loading={forumTopicLoading}>
            <Grid container justify="space-between" alignItems="center">
              <Typography variant="h5" noWrap>
                {intl.formatMessage({
                  id: "Forum.EditForumTopicDialog.EditForumTopic",
                  defaultMessage: "Edit Forum Topic"
                })}
              </Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <TextField
              name="title"
              variant="outlined"
              label={intl.formatMessage({
                id: "Forum.EditForumTopicDialog.Title",
                defaultMessage: "Title"
              })}
              fullWidth
            />
            <TextField
              name="body"
              variant="outlined"
              label={intl.formatMessage({
                id: "Forum.EditForumTopicDialog.Body",
                defaultMessage: "Body"
              })}
              fullWidth
              multiline
              rows={6}
            />
          </Loader>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            {intl.formatMessage({
              id: "Forum.EditForumTopicDialog.Close",
              defaultMessage: "Close"
            })}
          </Button>
          <SubmitButton variant="contained" color="primary" size="small">
            {intl.formatMessage({
              id: "Forum.EditForumTopicDialog.Save",
              defaultMessage: "Save"
            })}
          </SubmitButton>
        </DialogActions>
      </Dialog>
    </Formik>
  );
};

export default EditForumTopicDialog;
